import React, { Component } from 'react';
import moment from 'moment';

import Text from '@lightspeed/cirrus-text';

import { getDateFormat, getToday } from 'pages/utils/time';
import DateRangePicker from 'pages/components/DateRangePicker';
import TimeRangePicker from 'pages/components/TimeRangePicker';

const TODAY = getToday();

const presetDates = [
  { label: 'Today', startDate: TODAY, endDate: TODAY },
  {
    label: 'Yesterday',
    startDate: moment(TODAY).subtract(1, 'day'),
    endDate: moment(TODAY).subtract(1, 'day'),
    divider: true,
  },
  { label: 'This week', startDate: moment(TODAY).day(0), endDate: moment(TODAY) },
  { label: 'This month', startDate: moment(TODAY).startOf('month'), endDate: moment(TODAY) },
  {
    label: 'This year',
    startDate: moment(TODAY).startOf('year'),
    endDate: moment(TODAY),
    divider: true,
  },
  {
    label: 'Last week',
    startDate: moment(TODAY)
      .subtract(1, 'week')
      .startOf('week'),
    endDate: moment(TODAY)
      .subtract(1, 'week')
      .endOf('week'),
  },

  {
    label: 'Last month',
    startDate: moment(TODAY)
      .subtract(1, 'month')
      .startOf('month'),
    endDate: moment(TODAY)
      .subtract(1, 'month')
      .endOf('month'),
  },
  {
    label: 'Last year',
    startDate: moment(TODAY)
      .subtract(1, 'year')
      .startOf('year'),
    endDate: moment(TODAY)
      .subtract(1, 'year')
      .endOf('year'),
    divider: true,
  },
  {
    label: 'All time',
    startDate: moment(TODAY).subtract(2, 'years'),
    endDate: moment(TODAY),
  },
];

const VISIBLE_MONTHS = 2;

const initialVisibleMonth = ({ endDate }) => moment(endDate).subtract(1, 'month');

class AuditTrailHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      key: 1,
      dateFormat: undefined,
      startDate: TODAY,
      endDate: TODAY,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  async componentDidMount() {
    const dateFormat = await getDateFormat();
    this.setState(() => ({
      dateFormat,
    }));
  }

  handleChange({ startDate, endDate }) {
    const { key } = this.state;

    this.setState(() => ({
      key: key + 1,
      startDate,
      endDate,
    }));
  }

  render() {
    const { key, dateFormat, startDate, endDate } = this.state;

    return (
      <div className="cr-flex cr-flex-row">
        <div className="cr-inline-flex cr-flex-col cr-mr-2">
          <div className="cr-mb-1">
            <Text heading4 dimmed>
              Date
            </Text>
          </div>
          <DateRangePicker
            key={key}
            dateFormat={dateFormat}
            startDate={startDate}
            endDate={endDate}
            presetDates={presetDates}
            availableStartDate={moment(TODAY).subtract(2, 'years')}
            availableEndDate={moment(TODAY)}
            initialVisibleMonth={initialVisibleMonth}
            numberOfMonths={VISIBLE_MONTHS}
            onChange={this.handleChange}
          />
        </div>
        <div className="cr-inline-flex cr-flex-col">
          <div className="cr-mb-1">
            <Text heading4 dimmed>
              Time
            </Text>
          </div>
          <TimeRangePicker startDate={startDate} endDate={endDate} onChange={this.handleChange} />
        </div>
      </div>
    );
  }
}

export default AuditTrailHeader;
